import { init, track, setUserId, reset } from '@amplitude/analytics-browser';

let initialized = false;

export function analyticsInit() {
  if (initialized) return;
  const apiKey = process.env.REACT_APP_AMPLITUDE_API_KEY;
  if (!apiKey) return;

  init(apiKey, undefined, {
    defaultTracking: false,
    serverZone: 'US',
    logLevel: 0,
  });
  initialized = true;
}

export function analyticsSetUser(id: string) {
  analyticsInit();
  setUserId(id);
}

export function analyticsTrack(
  eventName: string,
  eventProps?: Record<string, unknown>
) {
  analyticsInit();
  track(eventName, eventProps);
}

// optional, for logout flows
export function analyticsReset() {
  reset();
  initialized = false;
}
